module.exports = __webpack_public_path__ + "static/media/patient-history-2.f23886d8.pdf";